module.exports = __webpack_public_path__ + "static/media/compulsory.fc007c5d.png";